module.exports = __webpack_public_path__ + "img/588x310-04.7b8f396d.png";